import React, { useEffect, useState } from "react";
import {
	Box,
	CircularProgress,
	Container,
	Fade,
	IconButton,
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import Page from "../../../components/Page";
import { useNavigate } from "react-router-dom";
import { getAlumnes } from "../../../database/API";
import MUIDataTable from "mui-datatables";
import Title from "../../../components/Title";
import { Add } from "@mui/icons-material";
import UsersColumns from "./Table/UsersColumns";
import UsersOptions from "./Table/UsersOptions";
import { styled } from "@mui/material";

const useStyles = styled((theme) => ({
	root: {
		backgroundColor: "white",
		minHeight: "100%",
	},
	container: {
		paddingTop: 40,
		paddingBottom: 40,
	},
}));

const getMuiTheme = () =>
	createTheme({
		overrides: {
			TableHead: {
				root: {
					fontSize: 23,
				},
			},
		},
	});

const UsersAdmin = () => {
	const classes = useStyles();
	const navigate = useNavigate();
	const [alumnes, setAlumnes] = useState();
	const [loading, setLoading] = useState(true);
	const columns = UsersColumns(alumnes);
	const options = UsersOptions(alumnes);

	useEffect(() => {
		const get = async () => {
			const { alumnes } = await getAlumnes();
			setAlumnes(alumnes);
			setLoading(false);
		};

		get();
	}, []);

	return (
		<Page className={classes.root} title={"Alumnes"}>
			<Container maxWidth={false} className={classes.container}>
				<Title
					title={"Alumnes"}
					subtitle={"Administra els alumnes inscrits"}
					button={
						<IconButton
							className={classes.addButton}
							onClick={() => navigate("nou")}
						>
							<Add />
						</IconButton>
					}
				/>
				<Box py={2} spacing={3}>
					{!loading ? (
						<Fade in={!loading}>
							<div>
								<ThemeProvider theme={getMuiTheme()}>
									<MUIDataTable
										data={alumnes}
										columns={columns}
										options={options}
									/>
								</ThemeProvider>
							</div>
						</Fade>
					) : (
						<CircularProgress />
					)}
				</Box>
			</Container>
		</Page>
	);
};

export default UsersAdmin;
